<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>person</md-icon>
          </div>
          <h4 class="title" v-if="!clientId">Create New Clients</h4>
          <h4 class="title" v-else>Update Clients</h4>
        </md-card-header>

        <md-card-content>
          <md-field>
            <label>Name</label>
            <md-input v-model="name" type="text"></md-input>
          </md-field>
          <md-field>
            <label>Company Name</label>
            <md-input v-model="companyName" type="text" :disabled="clientId"></md-input>
          </md-field>
          <md-field>
            <label>Email</label>
            <md-input v-model="email" type="email"></md-input>
          </md-field>
          <md-field>
            <label>Phone Number</label>
            <md-input v-model="phoneNumber" type="text"></md-input>
          </md-field>
          <md-field>
            <label>Address</label>
            <md-input v-model="address" type="text"></md-input>
          </md-field>
          <div class="md-layout">
            <div class="md-layout-item md-size-33">
              <md-field>
                <label>City</label>
                <md-input v-model="city" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-33">
              <md-field>
                <label>State</label>
                <md-input v-model="state" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-33">
              <md-field>
                <label>Country</label>
                <md-input v-model="country" type="text"></md-input>
              </md-field>
            </div>
          </div>
        </md-card-content>

        <md-card-actions md-alignment="left">
          <md-button v-if="!clientId" class="md-success" :disabled="isDisabled" @click="createClient()">
            Create <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
          </md-button>
          <md-button v-else class="md-success" :disabled="isDisabled" @click="updateClient()">
            Update <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
          </md-button>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>
<script>
import ClientsService from "../../services/ClientsService";
export default {
  components: {},
  data() {
    return {
      clientId: this.$route.query.id,
      isDisabled: false,
      name: "",
      companyName: "",
      email:"",
      phoneNumber: "",
      address:"",
      city:"",
      state:"",
      country:""
    };
  },
  methods: {
    async createClient() {
      this.isDisabled = true;
      let data = { name: this.name, companyName: this.companyName, email: this.email, phoneNumber: this.phoneNumber,
        address: this.address, city: this.city, state: this.state, country: this.country }
      await ClientsService.createClient(data)
        .then((response) => {
            this.isDisabled = false;
            this.$toast.success(response.data.respones_msg);
            this.$router.push('clients');
        }).catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
        });
    },
    async updateClient() {
      this.isDisabled = true;
      let data = { id: this.clientId, name: this.name, companyName: this.companyName, email: this.email, phoneNumber: this.phoneNumber,
        address: this.address, city: this.city, state: this.state, country: this.country }
      await ClientsService.updateClient(data)
        .then((response) => {
            this.isDisabled = false;
            this.$toast.success(response.data.respones_msg);
            this.$router.push('clients');
        }).catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
        });
    },
    async getClientDetail() {
      this.isDisabled = true;
      let data = { id: this.clientId }
      await ClientsService.getClientDetail(data)
        .then((response) => {
            this.isDisabled = false;
            let clientDetails = response.data.data
            this.name = clientDetails.name;
            this.companyName = clientDetails.companyName;
            this.email = clientDetails.email;
            this.phoneNumber = clientDetails.phoneNumber;
            this.address = clientDetails.address;
            this.city = clientDetails.city;
            this.state = clientDetails.state;
            this.country = clientDetails.country;
        }).catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
        });
    }
  },
  beforeMount() {
    if (this.$route.query.id) {
      this.getClientDetail();
    }
  }
};
</script>
<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}

.md-inline-checkboxes {
  display: inline-flex;

  .md-checkbox {
    margin-top: 15px !important;
  }
}

.md-checkbox,
.md-radio {
  margin-top: 15px;
  margin-bottom: 0.5rem;
}

.md-checkbox,
.md-radio {
  display: flex;
}

.md-radio .md-radio-container {
  margin-left: 5px;
  position: relative;
  left: -3px;
}

.md-form-label + .md-layout-item .md-checkbox:not(:first-child),
.md-form-label + .md-layout-item + .md-layout-item .md-radio:not(:first-child),
.md-form-label + .md-layout-item .md-radio {
  margin-top: 0;
}

.form-control-static {
  margin-top: 6px;
}
</style>
